import FeaturedCaseStudies from './FeaturedCaseStudies'

export default FeaturedCaseStudies
